<template>
  <div>
    <el-badge is-dot :hidden="filtersEmpty()">
      <el-button
        type="primary"
        class="btn-main"
        icon="el-icon-search"
        @click="openDialog()"
      >
        Filters
      </el-button>
    </el-badge>
    <el-dialog
      title="Filters"
      :visible.sync="dialog"
      width="500px"
      top="3vh"
      :modal="false"
    >
      <p>Artist</p>
      <el-input
        type="text"
        v-model="artist"
        clearable
        placeholder="Artist"
      />
      <p>Track</p>
      <el-input
        type="text"
        v-model="track"
        clearable
        placeholder="Track"
        class="mt10"
      />
      <p>Daterange for charts</p>
      <el-date-picker
        v-model="date_range"
        type="daterange"
        unlink-panels
        range-separator="-"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="dateRangeOptions"
        format="d MMMM yyyy"
        value-format="yyyy-MM-dd"
        @change="setDateRangeAndClose()"
      ></el-date-picker>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

export default {
  data() {
    return {
      dialog: false,
      artist: '',
      track: '',
      date_range: [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ]
    }
  },

  computed: {
    ...mapState('reportsTracks', ['loading'])
  },

  methods: {
    ...mapActions('reportsTracks', ['readTracks']),
    ...mapMutations('reportsTracks', [
      'setPage',
      'setPageSize',
      'setDateRange'
    ]),

    filter() {
      this.setPage(1)
      let filter_data = {
        artist: this.artist,
        track: this.track
      }
      localStorage.setItem('track_report_filter', JSON.stringify(filter_data))
      this.readTracks(filter_data)
      this.filtersEmpty()
      this.dialog = false
    },

    filtersEmpty() {
      let ls = JSON.parse(localStorage.getItem('track_report_filter'))
      if (ls) {
        const { page, page_size, ...active_filters } = ls

        let f = Object.values(active_filters).filter(function(n) {
          return n > 0 || n != ''
        })

        if (f != null && f.length) return false
      }

      return true
    },

    openDialog() {
      this.dialog = true

      let ls = localStorage.getItem('track_report_filter')
      let f = JSON.parse(ls)

      this.artist = f.artist
      this.track = f.track
    },

    setDateRangeAndClose() {
      this.setDateRange(this.date_range)
      this.dialog = false
    }
  },

  created() {
    this.filtersEmpty()
  }
}
</script>
